/* tslint:disable */
/* eslint-disable */
/**
 * K1 OpenAPI
 * API fuer die Nutzung der K1 REST-Schnittstelle
 *
 * The version of the OpenAPI document: 1.168.0-SNAPSHOT
 * Contact: diplan-backend@init.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorRest } from '../models';
// @ts-ignore
import type { PageTransferMessageUebersichtRest } from '../models';
// @ts-ignore
import type { TransferMessageDetailRest } from '../models';
// @ts-ignore
import type { TransferMessageStatuswechselRest } from '../models';
/**
 * TransferMessageResourceApi - axios parameter creator
 * @export
 */
export const TransferMessageResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann zu Testzwecken eine spezifische TransferMessage ins System eingespielt werden.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt, um für Testzwecke eingehende TransferMessage zu erzeugen.
         * @param {File} file Datei mit TransferMessage die eingespielt werden sollen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSimulatedTransferInMessage: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('createSimulatedTransferInMessage', 'file', file)
            const localVarPath = `/monitoring/transfermessages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine spezifische TransferMessage</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Löschen einer TransferMessage.
         * @param {number} transferMessageID ID der TransferMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransferMessage: async (transferMessageID: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transferMessageID' is not null or undefined
            assertParamExists('deleteTransferMessage', 'transferMessageID', transferMessageID)
            const localVarPath = `/monitoring/transfermessages/{transferMessageID}`
                .replace(`{${"transferMessageID"}}`, encodeURIComponent(String(transferMessageID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden die Metadaten einer spezifischen TransferMessage ausgeliefert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Ausliefern einer spezifischen TransferMessage.
         * @param {number} transferMessageID ID der TransferMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransferMessageDetail: async (transferMessageID: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transferMessageID' is not null or undefined
            assertParamExists('getTransferMessageDetail', 'transferMessageID', transferMessageID)
            const localVarPath = `/monitoring/transfermessages/{transferMessageID}`
                .replace(`{${"transferMessageID"}}`, encodeURIComponent(String(transferMessageID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden TransferMessages gesucht.<br> Die Ergebnismenge kann durch optionale Suchparameter eingeschränkt werden.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Suchen von TransferMessages.
         * @param {string} [processingtimeStart] Wenn angegeben muss die Transfermessage nach (gleich) diesem Datum erzeugt worden sein und es muss auch das Enddatum spezifiziert werden.
         * @param {string} [processingtimeEnd] Wenn angegeben muss die Transfermessage vor (gleich) diesem Datum erzeugt worden sein und es muss auch das Anfangsdatum spezifiziert werden.
         * @param {string} [messagetype] Message Typ
         * @param {Array<GetTransferMessageUebersichtSource>} [source] das System für welches die Tranfermessage ist
         * @param {Array<GetTransferMessageUebersichtDirection>} [direction] die Richtung der Transfermessage
         * @param {Array<GetTransferMessageUebersichtStatus>} [status] der Transferstatus
         * @param {string} [messageId] die Id der Message
         * @param {string} [vorgangsId] die Id des Vorgangs
         * @param {string} [messageText] Text in der Message
         * @param {string} [planId] die planId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<GetTransferMessageUebersichtSort>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransferMessageUebersicht: async (processingtimeStart?: string, processingtimeEnd?: string, messagetype?: string, source?: Array<GetTransferMessageUebersichtSource>, direction?: Array<GetTransferMessageUebersichtDirection>, status?: Array<GetTransferMessageUebersichtStatus>, messageId?: string, vorgangsId?: string, messageText?: string, planId?: string, page?: number, size?: number, sort?: Array<GetTransferMessageUebersichtSort>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitoring/transfermessages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (processingtimeStart !== undefined) {
                localVarQueryParameter['processingtimeStart'] = (processingtimeStart as any instanceof Date) ?
                    (processingtimeStart as any).toISOString() :
                    processingtimeStart;
            }

            if (processingtimeEnd !== undefined) {
                localVarQueryParameter['processingtimeEnd'] = (processingtimeEnd as any instanceof Date) ?
                    (processingtimeEnd as any).toISOString() :
                    processingtimeEnd;
            }

            if (messagetype !== undefined) {
                localVarQueryParameter['messagetype'] = messagetype;
            }

            if (source) {
                localVarQueryParameter['source'] = source;
            }

            if (direction) {
                localVarQueryParameter['direction'] = direction;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (messageId !== undefined) {
                localVarQueryParameter['messageId'] = messageId;
            }

            if (vorgangsId !== undefined) {
                localVarQueryParameter['vorgangsId'] = vorgangsId;
            }

            if (messageText !== undefined) {
                localVarQueryParameter['messageText'] = messageText;
            }

            if (planId !== undefined) {
                localVarQueryParameter['planId'] = planId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann der Status für mehrere TransferMessages gesetzt werden.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Setzen des Status für mehrere TransferMessages.
         * @param {TransferMessageStatuswechselRest} transferMessageStatuswechselRest enthält TransfermessageIDs und den Zielstatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMessageStatus: async (transferMessageStatuswechselRest: TransferMessageStatuswechselRest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transferMessageStatuswechselRest' is not null or undefined
            assertParamExists('updateMessageStatus', 'transferMessageStatuswechselRest', transferMessageStatuswechselRest)
            const localVarPath = `/monitoring/transfermessages/statuswechsel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferMessageStatuswechselRest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransferMessageResourceApi - functional programming interface
 * @export
 */
export const TransferMessageResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransferMessageResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann zu Testzwecken eine spezifische TransferMessage ins System eingespielt werden.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt, um für Testzwecke eingehende TransferMessage zu erzeugen.
         * @param {File} file Datei mit TransferMessage die eingespielt werden sollen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSimulatedTransferInMessage(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferMessageDetailRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSimulatedTransferInMessage(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferMessageResourceApi.createSimulatedTransferInMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine spezifische TransferMessage</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Löschen einer TransferMessage.
         * @param {number} transferMessageID ID der TransferMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTransferMessage(transferMessageID: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTransferMessage(transferMessageID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferMessageResourceApi.deleteTransferMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden die Metadaten einer spezifischen TransferMessage ausgeliefert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Ausliefern einer spezifischen TransferMessage.
         * @param {number} transferMessageID ID der TransferMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransferMessageDetail(transferMessageID: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferMessageDetailRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransferMessageDetail(transferMessageID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferMessageResourceApi.getTransferMessageDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden TransferMessages gesucht.<br> Die Ergebnismenge kann durch optionale Suchparameter eingeschränkt werden.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Suchen von TransferMessages.
         * @param {string} [processingtimeStart] Wenn angegeben muss die Transfermessage nach (gleich) diesem Datum erzeugt worden sein und es muss auch das Enddatum spezifiziert werden.
         * @param {string} [processingtimeEnd] Wenn angegeben muss die Transfermessage vor (gleich) diesem Datum erzeugt worden sein und es muss auch das Anfangsdatum spezifiziert werden.
         * @param {string} [messagetype] Message Typ
         * @param {Array<GetTransferMessageUebersichtSource>} [source] das System für welches die Tranfermessage ist
         * @param {Array<GetTransferMessageUebersichtDirection>} [direction] die Richtung der Transfermessage
         * @param {Array<GetTransferMessageUebersichtStatus>} [status] der Transferstatus
         * @param {string} [messageId] die Id der Message
         * @param {string} [vorgangsId] die Id des Vorgangs
         * @param {string} [messageText] Text in der Message
         * @param {string} [planId] die planId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<GetTransferMessageUebersichtSort>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransferMessageUebersicht(processingtimeStart?: string, processingtimeEnd?: string, messagetype?: string, source?: Array<GetTransferMessageUebersichtSource>, direction?: Array<GetTransferMessageUebersichtDirection>, status?: Array<GetTransferMessageUebersichtStatus>, messageId?: string, vorgangsId?: string, messageText?: string, planId?: string, page?: number, size?: number, sort?: Array<GetTransferMessageUebersichtSort>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTransferMessageUebersichtRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransferMessageUebersicht(processingtimeStart, processingtimeEnd, messagetype, source, direction, status, messageId, vorgangsId, messageText, planId, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferMessageResourceApi.getTransferMessageUebersicht']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann der Status für mehrere TransferMessages gesetzt werden.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Setzen des Status für mehrere TransferMessages.
         * @param {TransferMessageStatuswechselRest} transferMessageStatuswechselRest enthält TransfermessageIDs und den Zielstatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMessageStatus(transferMessageStatuswechselRest: TransferMessageStatuswechselRest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMessageStatus(transferMessageStatuswechselRest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferMessageResourceApi.updateMessageStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TransferMessageResourceApi - factory interface
 * @export
 */
export const TransferMessageResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransferMessageResourceApiFp(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann zu Testzwecken eine spezifische TransferMessage ins System eingespielt werden.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt, um für Testzwecke eingehende TransferMessage zu erzeugen.
         * @param {File} file Datei mit TransferMessage die eingespielt werden sollen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSimulatedTransferInMessage(file: File, options?: RawAxiosRequestConfig): AxiosPromise<TransferMessageDetailRest> {
            return localVarFp.createSimulatedTransferInMessage(file, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine spezifische TransferMessage</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Löschen einer TransferMessage.
         * @param {number} transferMessageID ID der TransferMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransferMessage(transferMessageID: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTransferMessage(transferMessageID, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden die Metadaten einer spezifischen TransferMessage ausgeliefert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Ausliefern einer spezifischen TransferMessage.
         * @param {number} transferMessageID ID der TransferMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransferMessageDetail(transferMessageID: number, options?: RawAxiosRequestConfig): AxiosPromise<TransferMessageDetailRest> {
            return localVarFp.getTransferMessageDetail(transferMessageID, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden TransferMessages gesucht.<br> Die Ergebnismenge kann durch optionale Suchparameter eingeschränkt werden.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Suchen von TransferMessages.
         * @param {string} [processingtimeStart] Wenn angegeben muss die Transfermessage nach (gleich) diesem Datum erzeugt worden sein und es muss auch das Enddatum spezifiziert werden.
         * @param {string} [processingtimeEnd] Wenn angegeben muss die Transfermessage vor (gleich) diesem Datum erzeugt worden sein und es muss auch das Anfangsdatum spezifiziert werden.
         * @param {string} [messagetype] Message Typ
         * @param {Array<GetTransferMessageUebersichtSource>} [source] das System für welches die Tranfermessage ist
         * @param {Array<GetTransferMessageUebersichtDirection>} [direction] die Richtung der Transfermessage
         * @param {Array<GetTransferMessageUebersichtStatus>} [status] der Transferstatus
         * @param {string} [messageId] die Id der Message
         * @param {string} [vorgangsId] die Id des Vorgangs
         * @param {string} [messageText] Text in der Message
         * @param {string} [planId] die planId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<GetTransferMessageUebersichtSort>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransferMessageUebersicht(processingtimeStart?: string, processingtimeEnd?: string, messagetype?: string, source?: Array<GetTransferMessageUebersichtSource>, direction?: Array<GetTransferMessageUebersichtDirection>, status?: Array<GetTransferMessageUebersichtStatus>, messageId?: string, vorgangsId?: string, messageText?: string, planId?: string, page?: number, size?: number, sort?: Array<GetTransferMessageUebersichtSort>, options?: RawAxiosRequestConfig): AxiosPromise<PageTransferMessageUebersichtRest> {
            return localVarFp.getTransferMessageUebersicht(processingtimeStart, processingtimeEnd, messagetype, source, direction, status, messageId, vorgangsId, messageText, planId, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann der Status für mehrere TransferMessages gesetzt werden.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Setzen des Status für mehrere TransferMessages.
         * @param {TransferMessageStatuswechselRest} transferMessageStatuswechselRest enthält TransfermessageIDs und den Zielstatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMessageStatus(transferMessageStatuswechselRest: TransferMessageStatuswechselRest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMessageStatus(transferMessageStatuswechselRest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransferMessageResourceApi - object-oriented interface
 * @export
 * @class TransferMessageResourceApi
 * @extends {BaseAPI}
 */
export class TransferMessageResourceApi extends BaseAPI {
    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann zu Testzwecken eine spezifische TransferMessage ins System eingespielt werden.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
     * @summary Endpunkt, um für Testzwecke eingehende TransferMessage zu erzeugen.
     * @param {File} file Datei mit TransferMessage die eingespielt werden sollen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferMessageResourceApi
     */
    public createSimulatedTransferInMessage(file: File, options?: RawAxiosRequestConfig) {
        return TransferMessageResourceApiFp(this.configuration).createSimulatedTransferInMessage(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine spezifische TransferMessage</p><p><b>Benötigte Rechte:</b> ADMIN</p>
     * @summary Endpunkt zum Löschen einer TransferMessage.
     * @param {number} transferMessageID ID der TransferMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferMessageResourceApi
     */
    public deleteTransferMessage(transferMessageID: number, options?: RawAxiosRequestConfig) {
        return TransferMessageResourceApiFp(this.configuration).deleteTransferMessage(transferMessageID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden die Metadaten einer spezifischen TransferMessage ausgeliefert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
     * @summary Endpunkt zum Ausliefern einer spezifischen TransferMessage.
     * @param {number} transferMessageID ID der TransferMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferMessageResourceApi
     */
    public getTransferMessageDetail(transferMessageID: number, options?: RawAxiosRequestConfig) {
        return TransferMessageResourceApiFp(this.configuration).getTransferMessageDetail(transferMessageID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden TransferMessages gesucht.<br> Die Ergebnismenge kann durch optionale Suchparameter eingeschränkt werden.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
     * @summary Endpunkt zum Suchen von TransferMessages.
     * @param {string} [processingtimeStart] Wenn angegeben muss die Transfermessage nach (gleich) diesem Datum erzeugt worden sein und es muss auch das Enddatum spezifiziert werden.
     * @param {string} [processingtimeEnd] Wenn angegeben muss die Transfermessage vor (gleich) diesem Datum erzeugt worden sein und es muss auch das Anfangsdatum spezifiziert werden.
     * @param {string} [messagetype] Message Typ
     * @param {Array<GetTransferMessageUebersichtSource>} [source] das System für welches die Tranfermessage ist
     * @param {Array<GetTransferMessageUebersichtDirection>} [direction] die Richtung der Transfermessage
     * @param {Array<GetTransferMessageUebersichtStatus>} [status] der Transferstatus
     * @param {string} [messageId] die Id der Message
     * @param {string} [vorgangsId] die Id des Vorgangs
     * @param {string} [messageText] Text in der Message
     * @param {string} [planId] die planId
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<GetTransferMessageUebersichtSort>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferMessageResourceApi
     */
    public getTransferMessageUebersicht(processingtimeStart?: string, processingtimeEnd?: string, messagetype?: string, source?: Array<GetTransferMessageUebersichtSource>, direction?: Array<GetTransferMessageUebersichtDirection>, status?: Array<GetTransferMessageUebersichtStatus>, messageId?: string, vorgangsId?: string, messageText?: string, planId?: string, page?: number, size?: number, sort?: Array<GetTransferMessageUebersichtSort>, options?: RawAxiosRequestConfig) {
        return TransferMessageResourceApiFp(this.configuration).getTransferMessageUebersicht(processingtimeStart, processingtimeEnd, messagetype, source, direction, status, messageId, vorgangsId, messageText, planId, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann der Status für mehrere TransferMessages gesetzt werden.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
     * @summary Endpunkt zum Setzen des Status für mehrere TransferMessages.
     * @param {TransferMessageStatuswechselRest} transferMessageStatuswechselRest enthält TransfermessageIDs und den Zielstatus
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferMessageResourceApi
     */
    public updateMessageStatus(transferMessageStatuswechselRest: TransferMessageStatuswechselRest, options?: RawAxiosRequestConfig) {
        return TransferMessageResourceApiFp(this.configuration).updateMessageStatus(transferMessageStatuswechselRest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetTransferMessageUebersichtSource = {
    BETEILIGUNG: 'BETEILIGUNG',
    OKTAGON: 'OKTAGON',
    CSW_T: 'CSW_T',
    DCAT_AP_PLU: 'DCAT_AP_PLU',
    DCAT_AP_EIA: 'DCAT_AP_EIA',
    VORHABEN_ANTRAG: 'VORHABEN_ANTRAG',
    VORHABEN_ANTRAGSDOKUMENTE: 'VORHABEN_ANTRAGSDOKUMENTE',
    VORHABEN_BAUANTRAG: 'VORHABEN_BAUANTRAG'
} as const;
export type GetTransferMessageUebersichtSource = typeof GetTransferMessageUebersichtSource[keyof typeof GetTransferMessageUebersichtSource];
/**
 * @export
 */
export const GetTransferMessageUebersichtDirection = {
    IN: 'IN',
    OUT: 'OUT'
} as const;
export type GetTransferMessageUebersichtDirection = typeof GetTransferMessageUebersichtDirection[keyof typeof GetTransferMessageUebersichtDirection];
/**
 * @export
 */
export const GetTransferMessageUebersichtStatus = {
    NEU: 'NEU',
    RETRY: 'RETRY',
    ERFOLGREICH: 'ERFOLGREICH',
    FEHLER: 'FEHLER',
    UNTERBROCHEN: 'UNTERBROCHEN'
} as const;
export type GetTransferMessageUebersichtStatus = typeof GetTransferMessageUebersichtStatus[keyof typeof GetTransferMessageUebersichtStatus];
/**
 * @export
 */
export const GetTransferMessageUebersichtSort = {
    messageID: 'messageID',
    messageIDasc: 'messageID,asc',
    messageIDdesc: 'messageID,desc',
    processingTime: 'processingTime',
    processingTimeasc: 'processingTime,asc',
    processingTimedesc: 'processingTime,desc',
    messageType: 'messageType',
    messageTypeasc: 'messageType,asc',
    messageTypedesc: 'messageType,desc',
    source: 'source',
    sourceasc: 'source,asc',
    sourcedesc: 'source,desc',
    direction: 'direction',
    directionasc: 'direction,asc',
    directiondesc: 'direction,desc',
    status: 'status',
    statusasc: 'status,asc',
    statusdesc: 'status,desc'
} as const;
export type GetTransferMessageUebersichtSort = typeof GetTransferMessageUebersichtSort[keyof typeof GetTransferMessageUebersichtSort];
